const ADMIN_TICKETS = {
  SET_TICKETS_QUERY: 'SET_ADMIN_TICKETS_QUERY',
};

export default ADMIN_TICKETS;
